import {
  __async
} from "./chunk-4AFQP74Z.js";

// src/lazyLoad.ts
import { create } from "zustand";
var lazyLoadStore = (loadData) => {
  const store = create((set, get) => ({
    data: void 0,
    load: () => __async(void 0, null, function* () {
      if (!get().data) {
        set({ data: yield loadData() });
      }
    })
  }));
  const caller = () => {
    const s = store();
    s.load();
    return s.data;
  };
  caller.getState = () => __async(void 0, null, function* () {
    yield store.getState().load();
    return store.getState().data;
  });
  return caller;
};
var lazyLoad = (lazyImport) => __async(void 0, null, function* () {
  const module = yield lazyImport();
  return module.default;
});
export {
  lazyLoad,
  lazyLoadStore
};
